import {
  Box,
  Divider,
  Fade,
  FormControl,
  Grid,
  Grow,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import useFetchAllActiveDivisi from "../../api/effects/queries/Divisi/useFetchAllActiveDivisi";
import useFetchAllLokasi from "../../api/effects/queries/Job/useFetchAllLokasi";
import HeaderGeneral from "../../components/Header/HeaderGeneral";
import { AllDivisiActiveResponse } from "../../models/Divisi";
import { AllLokasiResponse, JobResponse } from "../../models/Job";
import JobSearchBar from "./Components/JobSearchBar";
import JobCard from "../../components/JobCard";
import { useFetchAllJob } from "../../api/effects/mutations/Job/useFetchAllJob";
import { Footer } from "../../components/Footer/Footer";
import { useFetchAllJobQuery } from "../../api/effects/queries/Job/useFetchAllJobQuery";

const BaseBox = styled(Box)(({ theme }) => ({
  marginTop: "0",
  height: "95vh",
  width: "100%",
}));



const JobListBox = styled(Box)(({ theme }) => ({
  marginTop: "0",
  height: "100%",
  width: "100%",
}));

const BaseContentBox = styled(Box)(({ theme }) => ({
  marginTop: "0",
  height: "50vh",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    height: "100vh",
  },
}));

const HeroGrid = styled(Grid)(({ theme }) => ({
  paddingTop: "30vh",
  paddingLeft: "5%",
  [theme.breakpoints.down("md")]: {
    paddingTop: "10vh",
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: "5vh",
  },
}));

const ContentImageGrid = styled(Grid)(({ theme }) => ({
  height: "50vh",
  width: "auto",
  padding: "5%",
  paddingTop: "5vh",
  paddingBottom: "5vh",
  [theme.breakpoints.down("md")]: {
    height: "auto",
    width: "100vw",
  },
}));

const ContentGrid = styled(Grid)(({ theme }) => ({
  height: "50vh",
  width: "auto",
  padding: "5%",
  paddingTop: "5vh",
  paddingBottom: "5vh",
  [theme.breakpoints.down("md")]: {
    paddingTop: "10vh",
    height: "auto",
    width: "100vw",
  },
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: "white",
  fontWeight: "bolder",
  display: "inline-block",
}));

const SubTitleText = styled(Typography)(({ theme }) => ({
  color: "black",
  fontWeight: "bolder",
  display: "inline-block",
}));

const MediumDivider = styled(Divider)(({ theme }) => ({
  width: "90vw",
  paddingTop: "5vh",
  [theme.breakpoints.down("md")]: {
    paddingTop: "10vh",
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: "20vh",
  },
}));

const JobTitleGrid = styled(Grid)({
  paddingTop: "10vh",
  width: "100%",
  textAlign: "center",
});

const ListGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up("xs")]: {
    paddingLeft: "5%",
  },
  [theme.breakpoints.up("md")]: {
    paddingLeft: "4%",
  },
  [theme.breakpoints.up("lg")]: {
    paddingLeft: "4%",
  },
  height: "auto",
  width: "100%",
}));

const TitleItemGrid = styled(Grid)({
  paddingLeft: "1%",
  width: "100%",
  textAlign: "left",
});

type Props = {};

export default function HomePage({ }: Props) {
  const [enter, setEnter] = useState(false);
  const [search, setSearch] = useState("");
  const [divisi, setDivisi] = useState("");
  const [lokasi, setLokasi] = useState("");

  const { data: allLokasiData } = useFetchAllLokasi();
  const { data: allActiveDivisiData } = useFetchAllActiveDivisi();

  const [Divisidata, setDivisiData] = useState<AllDivisiActiveResponse[]>([]);
  const [Lokasidata, setLokasiData] = useState<AllLokasiResponse[]>([]);
  const [Jobdata, setJobData] = useState<JobResponse[]>([]);

  const { data: initialJobData } = useFetchAllJobQuery(
    { search: "", lokasi: "", divisi: "" },
    {
      enabled: !!allLokasiData && !!allActiveDivisiData,
      refetchOnWindowFocus: false,
    }
  );

  const { mutateAsync: GetJobData } = useFetchAllJob({
    onSuccess(data: React.SetStateAction<JobResponse[]>) {
      setJobData(data);
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });


  useEffect(() => {
    if (initialJobData) {
      setJobData(initialJobData);
    }
  }, [initialJobData])

  useEffect(() => {
    if (allActiveDivisiData !== undefined) {
      setDivisiData(allActiveDivisiData);
    }
    if (allLokasiData !== undefined) {
      setLokasiData(allLokasiData);
    }
    setEnter(!enter);
  }, [allActiveDivisiData, allLokasiData]);

  // const { data: allJobData } = useFetchAllJob(
  //   search,
  //   lokasi,
  //   Divisidata.find((e) => e.value === divisi)?.text
  //     ? Divisidata.find((e) => e.value === divisi)!.text
  //     : ""
  // );

  // useEffect(() => {
  //   GetJobData({
  //     search: search,
  //     lokasi: lokasi,
  //     divisi: divisi,
  //   });
  // }, [enter]);

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const handleDivisi = (e: any) => {
    setDivisi(e.target.value);
  };

  const handleLokasi = (e: any) => {
    setLokasi(e.target.value);
  };

  const myRef = useRef<null | HTMLDivElement>(null);

  const handleSearchButton = () => {
    GetJobData({
      search: search,
      lokasi: lokasi,
      divisi: Divisidata.find((e) => e.value === divisi)?.text
        ? Divisidata.find((e) => e.value === divisi)!.text
        : "",
    });
    if (myRef.current !== null) {
      myRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Box>
        <HeaderGeneral />
        <BaseBox
          sx={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/HomeBG.jpg)`,
            position: "relative",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <Fade in={true}>
            <HeroGrid container>
              <Grid item xs={12}>
                <TitleText variant="h2">Mulailah karir anda</TitleText>
              </Grid>
              <Grid item xs={12}>
                <TitleText variant="h2">
                  dengan <span style={{ color: "#00ACED" }}>Kami</span>
                </TitleText>
              </Grid>
              <Grid item xs={12} sx={{ paddingTop: "2vh" }}>
                <Typography color="white">
                  Temukan Pekerjaan Baru Anda Sekarang !
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
              <Typography color="white">
                Browse the job you want and apply wherever you want
              </Typography>
            </Grid> */}
              <Grid item xs={12} sx={{ paddingTop: "4vh" }}>
                <JobSearchBar
                  width={{ md: "90vw", lg: "90vw", xl: "90vw" }}
                  search={search}
                  handleEditSearch={handleSearch}
                  divisi={divisi}
                  divisiData={Divisidata}
                  handleEditDivisi={handleDivisi}
                  lokasi={lokasi}
                  lokasiData={Lokasidata}
                  handleEditLokasi={handleLokasi}
                  handleSearch={handleSearchButton}
                />
              </Grid>
            </HeroGrid>
          </Fade>
        </BaseBox>
        <Fade in={true}>
          <BaseContentBox>
            <Grid container direction="row">
              <ContentImageGrid
                container
                justifyContent="center"
                alignContent="flex-start"
                item
                sm={12}
                md={6}
              >
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/images/Home1.jpg`}
                  alt="FotoHome1"
                  sx={{
                    objectFit: "cover",
                    height: "40vh",
                    maxWidth: "100%",
                    width: "auto",
                  }}
                />
              </ContentImageGrid>
              <ContentGrid
                container
                justifyContent="center"
                alignContent="flex-start"
                item
                sm={12}
                md={6}
              >
                <Grid item xs={12}>
                  <SubTitleText variant="h3">Tentang</SubTitleText>
                </Grid>
                <Grid item xs={12}>
                  <SubTitleText variant="h3">
                    <span style={{ color: "#00ACED" }}>Indomobil</span>
                  </SubTitleText>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="black">
                    PT Indomobil Sukses Internasional Tbk (Perseroan) merupakan
                    suatu kelompok usaha terpadu yang memiliki beberapa anak
                    perusahaan yang bergerak di bidang otomotif yang terkemuka di
                    Indonesia.
                  </Typography>
                </Grid>
              </ContentGrid>
            </Grid>
          </BaseContentBox>
        </Fade>
        <Fade in={true}>
          <BaseContentBox>
            <Grid container direction="row">
              <ContentGrid
                container
                justifyContent="center"
                alignContent="flex-start"
                item
                sm={12}
                md={6}
                sx={{ textAlign: "right" }}
              >
                <Grid item xs={12}>
                  <SubTitleText variant="h3">Berkarir di</SubTitleText>
                </Grid>
                <Grid item xs={12}>
                  <SubTitleText variant="h3">
                    <span style={{ color: "#00ACED" }}>Indomobil</span>
                  </SubTitleText>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="black">
                    Sebagai salah satu misi dari Indomobil yaitu mengembangkan
                    seluruh sumber daya yang dimiliki (salah satunya SDM) secara
                    berkesinambungan untuk meningkatkan profesionalisme bagi
                    kepuasan pelanggan, untuk itu Indomobil mengajak para individu
                    yang profesional dan berkemauan untuk bekerja keras agar bisa
                    bergabung bersama Indomobil.
                  </Typography>
                </Grid>
              </ContentGrid>
              <ContentImageGrid
                container
                justifyContent="center"
                alignContent="flex-start"
                item
                sm={12}
                md={6}
              >
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/images/Home2.png`}
                  alt="FotoHome1"
                  sx={{
                    objectFit: "cover",
                    height: "40vh",
                    maxWidth: "100%",
                    width: "auto",
                  }}
                />
              </ContentImageGrid>
            </Grid>
          </BaseContentBox>
        </Fade>
        <Grid container justifyContent="center">
          <MediumDivider />
        </Grid>
        <JobListBox ref={myRef}>
          <JobTitleGrid container justifyContent="center" alignItems="center">
            <Grid item xs={12}>
              <SubTitleText variant="h2">
                Lowongan <span style={{ color: "#00ACED" }}>Kerja</span>
              </SubTitleText>
            </Grid>
            <Grid item xs={12} sx={{ paddingTop: "2%" }}>
              <Typography>Mulailah karirmu bersama kami!</Typography>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              item
              xs={12}
              sx={{ paddingTop: "2%", paddingBottom: "4vh" }}
            >
              <Box sx={{ paddingLeft: "5%" }}>
                <JobSearchBar
                  width={{ md: "90vw", xl: "90vw" }}
                  search={search}
                  handleEditSearch={handleSearch}
                  divisi={divisi}
                  divisiData={Divisidata}
                  handleEditDivisi={handleDivisi}
                  lokasi={lokasi}
                  lokasiData={Lokasidata}
                  handleEditLokasi={handleLokasi}
                  handleSearch={handleSearchButton}
                />
              </Box>
            </Grid>
          </JobTitleGrid>
          <Grid container justifyContent="center" alignItems="center">
            {Divisidata.map((value, key) =>
              Jobdata.filter((Jobvalue) => Jobvalue.DIVISI == value.text)
                .length < 1 ? (
                <span key={key} />
              ) : (
                <Grow in={true} key={`${value.value}-${key}`} >
                  <ListGrid
                    container
                    direction="row"
                    justifyContent="flex-start"
                  >
                    <TitleItemGrid item>
                      <Typography variant="h4">{value.text}</Typography>
                    </TitleItemGrid>
                    {Jobdata.filter((Jobvalue) =>
                      Jobvalue.DIVISI == value.text
                    ).map((filteredValue) => (
                      <JobCard
                        key={filteredValue.JOB_ID}
                        Job={filteredValue}
                        ButtonLink={`/Job/${filteredValue.JOB_ID}`}
                        ButtonText="Detail"
                        Sizexs={11}
                        Sizemd={3.58}
                        Sizelg={3.63}
                        Sizexl={3.58}
                      />
                    ))}
                  </ListGrid>
                </Grow>
              )
            )}
          </Grid>
        </JobListBox>
        <Footer />
      </Box>
     
    </>
  );
}
